<template>
  <v-footer color="#163626" style="padding: 32px">
    <v-col class="px-0 py-0 text-center" cols="12">
      <span class="footer-text">
        © {{ new Date().getFullYear() }} Vivamus GmbH. Alle Rechte vorbehalten.
      </span>
    </v-col>
  </v-footer>
</template>

<script>
export default {};
</script>

<style scoped>
.footer-text {
  color: #fafafa;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
</style>